import { render, staticRenderFns } from "./BusinessCooperation.vue?vue&type=template&id=37ae7a7f&scoped=true&"
import script from "./BusinessCooperation.vue?vue&type=script&lang=js&"
export * from "./BusinessCooperation.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCooperation.vue?vue&type=style&index=0&id=37ae7a7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae7a7f",
  null
  
)

export default component.exports